import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Button } from '../ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Mínimo de TCP para despachar, por tipo de aeronave (solo admin edita; auditado).
// deferred: en el alta de aeronave el valor se guarda junto con la aeronave (no al instante).
export function TcpMinimumField({ aircraftType, maxPassengers, deferred = false, value, onDeferredChange }) {
    const type = (aircraftType || '').trim().toUpperCase();
    const [info, setInfo] = useState(null);
    const [val, setVal] = useState('');
    const [canEdit, setCanEdit] = useState(false);
    useEffect(() => {
        if (type.length < 2) { setInfo(null); return undefined; }
        const t = setTimeout(() => axios.get(`${API}/fleet/tcp-minimums`).then(r => {
            setCanEdit(r.data.can_edit);
            const it = r.data.items.find(i => i.aircraft_type === type) || null;
            setInfo(it);
            if (!deferred) setVal(it?.configured ?? '');
        }).catch(() => setInfo(null)), 400);
        return () => clearTimeout(t);
    }, [type, deferred]);
    if (type.length < 2) return null;
    const pax = Number(maxPassengers) || 0;
    const def = pax > 19 ? Math.max(1, Math.ceil(pax / 50)) : 0;
    const shown = deferred ? (value ?? '') : val;
    const save = async (v) => {
        try {
            await axios.put(`${API}/fleet/tcp-minimums/${encodeURIComponent(type)}`, { min_tcp: v === '' ? null : Number(v) });
            setInfo(i => ({ ...(i || {}), configured: v === '' ? null : Number(v) }));
            toast.success(`Mínimo de TCP para ${type} guardado`);
        } catch (e) { toast.error(e.response?.data?.detail || 'No se pudo guardar'); }
    };
    return (
        <div className="space-y-1.5 col-span-2 rounded-md border border-border/40 p-2" data-testid="tcp-min-field">
            <Label>TCP mínimos para despachar · tipo {type}</Label>
            <div className="flex flex-wrap items-center gap-2">
                <Input type="number" min="0" max="20" value={shown} disabled={!canEdit} placeholder={`Cálculo estándar: ${def}`}
                    onChange={e => (deferred ? onDeferredChange?.(e.target.value) : setVal(e.target.value))} className="w-56" data-testid="tcp-min-input" />
                {canEdit && !deferred && <Button type="button" size="sm" variant="outline" onClick={() => save(val)} data-testid="tcp-min-save">Guardar</Button>}
                {canEdit && !deferred && info?.configured != null && <Button type="button" size="sm" variant="ghost" onClick={() => { setVal(''); save(''); }} data-testid="tcp-min-reset">Usar cálculo estándar</Button>}
            </div>
            <p className="text-xs text-muted-foreground" data-testid="tcp-min-help">
                {info?.configured != null ? `Configurado: ${info.configured} TCP para todos los ${type}.` : `Sin configurar: 1 TCP por cada 50 asientos (o fracción) si hay más de 19 → ${def} con ${pax} asientos.`}
                {deferred && canEdit && ' Se guarda al registrar la aeronave y aplica a todo el tipo.'}
                {!canEdit && ' Solo el administrador lo edita.'}
            </p>
        </div>
    );
}
